import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-celular2',
  templateUrl: './text-celular2.component.html',
  styleUrls: ['./text-celular2.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextCelular2Component implements OnInit {
  
  constructor( ) { }

  ngOnInit() { }

}
